// Returns the raw JWT from the stored user session for the Socket.IO handshake.
// Unlike the HTTP Authorization header (which is prefixed with "Bearer "), the
// socket server reads the bare token via socket.handshake.auth.token, so we send
// it unprefixed. Read lazily (on each connection attempt) so a token obtained
// after login — or refreshed on reconnect — is picked up without recreating the
// socket.
export const getSocketAuthToken = () => {
  try {
    const session = JSON.parse(localStorage.getItem("usersession"));
    return session && session.token ? session.token : undefined;
  } catch (e) {
    return undefined;
  }
};

// socket.io-client `auth` callback form: invoked on every (re)connection attempt.
export const socketAuth = (cb) => cb({ token: getSocketAuthToken() });
